import r from "./index.es498.js";
import o from "./index.es499.js";
function u(t) {
  return r(o(t), {
    attribute: !0
  });
}
export {
  u as default
};
//# sourceMappingURL=index.es473.js.map
